/** @jsxImportSource @emotion/react */
import { FormattedMessage } from "react-intl";

import { css } from "@emotion/react";

import CustumError from "../../types/error";

interface ErrorProps {
  error: CustumError;
}

const containerStyle = css({
  margin: "auto",
  padding: "8px",
});

const Error = ({ error }: ErrorProps): JSX.Element => {
  // eslint-disable-next-line no-console
  console.error(error.message);

  return (
    <div css={containerStyle}>
      <FormattedMessage id={error.intlId} />
      {` (${error.code}) `}
      {error.hintIntlId && <FormattedMessage id={error.hintIntlId} />}
    </div>
  );
};
export default Error;
